module.exports = __webpack_public_path__ + "821ef14e10a997871e99a3cb7d82b323.svg";